export default __webpack_public_path__ + "static/logo-a8b429087c65e0c11c9551436ecf860e.png";